import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRole } from '../Role/Role';
import styles from "./LandingPage.module.scss";



const LandingPage: React.FC = () => {

    const { setRole } = useRole();
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem("role");
    }, []);

    const [selectedRole, setSelectedRole] = useState<"distributor" | "retailer" | null>(null);

    const handleRoleClick = (role: "distributor" | "retailer") => {
        setRole(role);
        navigate(`/${role}/login`);
    };

    return (
        <div>
            <div className={styles.logoText}>
                <span className={styles.logoHighlight}>Distributor / </span>
                <span className={styles.logoNormal}>Portal</span>
            </div>

            {/* Title */}
            <h2 className={styles.title}>
                Choose user type
            </h2>
            <div className={styles.cardContainer}>
                <div onClick={() => handleRoleClick("retailer")} className={styles.card}>
                    <img src="\assets\media\merchant_3857265.png"
                        alt="Retailer"
                        style={{ objectFit: "contain" }}
                        className={styles.img_size}
                    />
                    <span style={{ fontSize: "14px", fontWeight: 600 }}>Retailer</span>
                </div>
                <div onClick={() => handleRoleClick("distributor")} className={styles.card}>
                    <img src="\assets\media\supplier_17627533.png"
                        style={{ objectFit: "contain" }} />
                    <span style={{ fontSize: "14px", fontWeight: 600 }}>Distributor</span>
                </div>
            </div>
        </div>
    );
}

export default LandingPage; 